import "./voeux.scss";
import $ from 'jquery';

if($('#message').length > 0){
    $('.message-copie').html($('#message').html());
}

//VALIDATION DU FORMULAIRE
// Fetch all the forms we want to apply custom Bootstrap validation styles to
var forms = document.getElementsByClassName('needs-validation');
// Loop over them and prevent submission
var validation = Array.prototype.filter.call(forms, function(form) {
    form.addEventListener('submit', function(event) {
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        form.classList.add('was-validated');
    }, false);
});

$('#votreMessage').change(function(){
   console.log($(this).val());
});

$('#previsualiser').click(function(){
    $('.message-container p.message').empty().html($('#votreMessage').val());
    $("html, body").animate({ scrollTop: 110 }, 500);
});

